(function () {
  'use strict';

  var data = JSON.parse(document.getElementById('packs-data').textContent);
  var packs = data.packs;

  // Izabrani paket (podrazumevano 3 pakovanja). Svi buy boxovi su sinhronizovani.
  window.DEEP_SLEEP_SELECTED = data.defaultSelected;

  function formatPrice(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function selectPack(index) {
    window.DEEP_SLEEP_SELECTED = index;
    document.querySelectorAll('[data-pick]').forEach(function (btn) {
      var on = Number(btn.getAttribute('data-pick')) === index;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-cta-total]').forEach(function (el) {
      el.textContent = formatPrice(packs[index].total);
    });
    document.querySelectorAll('[data-cta-note]').forEach(function (el) {
      el.textContent = packs[index].ctaNote;
    });
    document.querySelectorAll('[data-pick]').forEach(function (btn) {
      var extras = btn.querySelector('.pack__extras');
      if (!extras) return;
      var on = Number(btn.getAttribute('data-pick')) === index;
      extras.hidden = !on;
    });
  }

  function updateHeaderCartCount(count) {
    var shown = count < 100 ? String(count) : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = shown;
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', count === 0);
    });
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      if (typeof icon.renderCartBubble !== 'function') return;
      try { icon.renderCartBubble(count, false, true); } catch (e) {}
    });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { itemCount: count, source: 'noro-magnesium' } }
    }));
  }

  function addToCart(button) {
    var pack = packs[window.DEEP_SLEEP_SELECTED];
    if (!pack) return;
    document.dispatchEvent(new CustomEvent('deepsleep:add-to-cart', {
      detail: { variantId: pack.variantId, qty: pack.qty, total: pack.total, currency: data.currency }
    }));
    var id = String(pack.variantId || data.fallbackVariantId || '');
    if (!/^\d+$/.test(id)) return;
    var cartQty = pack.cartQty || pack.qty || 1;
    var buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(function (btn) { btn.disabled = true; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: cartQty }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (cartRes) {
        return cartRes.json();
      });
    }).then(function (cart) {
      updateHeaderCartCount(cart && cart.item_count ? cart.item_count : cartQty);
      window.location.href = '/cart';
    }).catch(function () {
      buttons.forEach(function (btn) { btn.disabled = false; });
      if (button) button.textContent = 'Pokušaj ponovo';
    });
  }

  function showImage(thumb) {
    var main = document.querySelector('[data-gallery-main]');
    var srcset = thumb.getAttribute('data-srcset');
    if (srcset) main.setAttribute('srcset', srcset);
    else main.removeAttribute('srcset');
    main.src = thumb.getAttribute('data-thumb');
    main.alt = thumb.getAttribute('data-alt');
    document.querySelectorAll('[data-thumb]').forEach(function (b) {
      var on = b === thumb;
      b.classList.toggle('is-active', on);
      if (on) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }

  function toggleFaq(btn) {
    var answer = document.getElementById(btn.getAttribute('aria-controls'));
    var open = answer.hasAttribute('hidden');
    answer.toggleAttribute('hidden', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('.faq-item__icon').textContent = open ? '−' : '+';
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var el;
    if ((el = t.closest('[data-pick]'))) return selectPack(Number(el.getAttribute('data-pick')));
    if ((el = t.closest('[data-add-to-cart]'))) return addToCart(el);
    if ((el = t.closest('[data-thumb]'))) return showImage(el);
    if ((el = t.closest('[data-faq]'))) return toggleFaq(el);
  });

  // U editoru teme: blok "Slika galerije" izabran u bočnoj traci postaje velika slika.
  document.addEventListener('shopify:block:select', function (ev) {
    var thumb = ev.target.closest && ev.target.closest('[data-thumb]');
    if (thumb) showImage(thumb);
  });

  // Sticky traka se pojavljuje tek kad posetilac prođe sekciju "Zvuči poznato?"
  // (njen kraj uđe u ekran), a nestaje kad se vrati iznad nje - i posle skoka na sidro.
  var bar = document.querySelector('.sticky-bar');
  var after = document.querySelector('[data-sticky-after]');
  if (bar) {
    var ticking = false;
    var checkBar = function () {
      ticking = false;
      bar.classList.toggle('is-visible', !after || after.getBoundingClientRect().bottom < window.innerHeight);
    };
    var queueCheck = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(checkBar); }
    };
    window.addEventListener('scroll', queueCheck, { passive: true });
    window.addEventListener('resize', queueCheck);
    checkBar();
  }

  // Tabela poređenja se na uskim ekranima skroluje u stranu: naznaka + senke na ivicama.
  document.querySelectorAll('[data-scroll-frame]').forEach(function (frame) {
    var sc = frame.querySelector('[data-scroll]');
    var hint = frame.previousElementSibling;
    if (!hint || !hint.hasAttribute('data-scroll-hint')) hint = null;
    function update() {
      var max = sc.scrollWidth - sc.clientWidth;
      var overflow = max > 2;
      if (hint) {
        hint.hidden = !overflow;
        if (sc.scrollLeft > 20) hint.classList.add('is-used');
      }
      frame.classList.toggle('can-left', overflow && sc.scrollLeft > 2);
      frame.classList.toggle('can-right', overflow && sc.scrollLeft < max - 2);
    }
    sc.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
